<!-- 402人工审核等待状态 login页面code=401 跳转至该页面
添加证书页面上传成功就跳转到该页面-->
<template>
    <div class="contactStaff">
        <div>
            <img class="com-img" src="./images/btn_shenhe_nor.png" />
            <div class="com-text">审核中</div>
            <div class="com-text1">您的信息已提交，请等待工作人员审核</div>
            <div class="lworkDiv" @click="revocate">
                <div class="lwork1">撤销申请，完善信息</div>
            </div>
            <el-button class="hwork" type="primary" @click="contact">点击拨打工作人员电话 024-31975882</el-button>
            <div class="call-tip">如长时间未审核，请联系工作人员</div>
        </div>
        <!-- 弹窗 -->
        <div>
            <van-popup v-model="drawer" round position="bottom" :style="{ height: '30%' }">
                <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">工作人员联系电话</div>
                <a :href="'tel:02431975882'">
                    <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">024-31975882</div>
                </a>
                <div class="com-item" @click="drawer = false">取消</div>
            </van-popup>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            drawer: false,
        }
    },
    created() {
        // this.showAnimation()
        // 审核成功 跳实名认证页
        // this.$router.push("/realName");
    },
    methods: {
        //联系工作人员
        contact() {
            this.drawer = true;
        },
        // 撤销工作人员申请 并且清空用户创建的账户
        revocate() {
            // SchoolCard
            this.$router.push("/userData");
        },
        handleClose() {

        },
    }
}
</script>

<style lang="less">
.contactStaff {
    position: relative;
    background: #FFFFFF;
    min-height: 100vh;

    .com-img {
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        height: 37.5vw;
        width: 50%;
    }

    .com-text {
        position: absolute;
        top: 32%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.7rem;
        font-weight: 400;
        color: #333333;
    }

    .com-text1 {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1rem;
        width: 86%;
        text-align: center;
        line-height: 1.5;
        word-break: break-word;
        font-weight: 400;
        color: #333333;
    }

    .lworkDiv {
        position: absolute;
        top: 64%;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        background-color: #00706E;
        font-size: 1.1rem;
        color: #fff;
        border-radius: 35px;
        display: flex;
        justify-content: center;

        .lwork1 {
            padding: 10px;
        }
    }

    .hwork {
        position: absolute;
        top: 75%;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 40px;
        border-radius: 35px;
        background: #ffffff;
        color: #00706E;
        border: 1px solid #00706E;
        font-size: 1rem;
        padding: 0;
    }

    .call-tip {
        position: absolute;
        top: 83%;
        left: 50%;
        transform: translateX(-50%);
        width: 86%;
        text-align: center;
        color: #666666;
        font-size: 0.9rem;
        line-height: 1.4;
    }

}

.el-button+.el-button {
    margin-left: 9%;
}

// .bot-drawer{
//     border-radius: 30px 30px 0 0;
// }
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}

.el-button+.el-button {
    margin: auto;
}

// 底部弹出层
.com-item {
    text-align: center;
    font-size: 1.2rem;
    padding: 20px 0;
}

a {
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/contactStaff.vue